import { Component } from '@angular/core';

@Component({
  selector: 'app-centered-scrollable-content',
  templateUrl: './centered-scrollable-content.component.html',
  styleUrls: ['./centered-scrollable-content.component.scss']
})
export class CenteredScrollableContent {
}
